/**
 * Jaccard-like token overlap for German text.
 * Returns 0–1 where 1 = identical token sets.
 */
export function getTokenOverlap(a: string, b: string): number {
  const tokenize = (s: string) =>
    new Set(
      s
        .toLowerCase()
        .replace(/[^\w\säöüß]/g, '')
        .split(/\s+/)
        .filter((w) => w.length > 2)
    );
  const setA = tokenize(a);
  const setB = tokenize(b);
  if (setA.size === 0 || setB.size === 0) return 0;
  const intersection = new Set([...setA].filter((x) => setB.has(x)));
  return intersection.size / Math.min(setA.size, setB.size);
}
